import React, { Component } from "react";
import Tooltip from "./../shared/Tooltip";
import ToggleDrawer from "../shared/containers/ToggleDrawer";
import Store from "./../../content/Store";
import { CoverBenefitRow } from "./CoverBenefitRow";
import Media from "react-media";
import { Breakpoints } from "../../constants/CssConstants";
import style from "../../assets/css/modules/cover/cover-benefit-section.css";
import TooltipIcon from "../shared/form/TooltipIcon";
import { SubBenefits } from "../../constants/Constants";

export default class CoverBenefitSection extends Component {
  constructor(props) {
    super(props);
    this.state = { toolTipVisible: false };
  }

  onTooltipToggle = () => {
    this.setState({
      toolTipVisible: !this.state.toolTipVisible
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className={"col-12 benefitHeading " + style.benefitHeading}>
            {this.props.benefit ? (
              <React.Fragment>
                <h3>
                  {this.props.benefit.Description}
                  {Store.BenefitSectionTooltips[
                    this.props.benefit.BenefitSummaryConst
                  ] ? (
                    <TooltipIcon
                      customStyle={style.tooltipIcon}
                      onToggle={this.onTooltipToggle}
                      ariaLabel={
                        "Further information on " +
                        this.props.benefit.Description
                      }
                    />
                  ) : null}
                </h3>

                {Store.BenefitSectionTooltips[
                  this.props.benefit.BenefitSummaryConst
                ] ? (
                  <div>
                    <ToggleDrawer
                      isOpen={this.state.toolTipVisible}
                      gradientClass="primary"
                      bottom
                    >
                      <Tooltip
                        text={
                          Store.BenefitSectionTooltips[
                            this.props.benefit.BenefitSummaryConst
                          ]
                        }
                        customStyle={style.tooltip}
                      />
                    </ToggleDrawer>
                  </div>
                ) : null}

                <Media query={Breakpoints.lgUp}>
                  {(matches) =>
                    matches ? (
                      <CoverBenefitRow
                        subBenefit={{
                          Description: [{ Name: "" }],
                          Limits: "Limits",
                          Remaining: "Remaining",
                          Used: "Used"
                        }}
                        isHeader
                      />
                    ) : null
                  }
                </Media>

                {this.props.benefit.SubBenefits &&
                  this.props.benefit.SubBenefits.map((subBenefit, index) =>
                    subBenefit.SubBenefitType === SubBenefits.StrongerMinds ? (
                      <CoverBenefitRow
                        subBenefit={subBenefit}
                        key={index}
                        mergedColumnsDescription={this.props.ProductType!=="Business Protect"? Store.Cover.MentalHealth:Store.Cover.MentalHealthBusinessProtect}
                      />
                    ) : (
                      <CoverBenefitRow subBenefit={subBenefit} key={index} />
                    )
                  )}
              </React.Fragment>
            ) : null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
